import React, { useState, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useUserContext } from '../../../context_providers/user_context/UserProvider';
import { useToast } from '../../../context_providers/toast_context/ToastContext';
import { ToastType } from '../../../context_providers/toast_context/ToastContext';
import BearerTokenIcon from '../../../resources/images/bearer_token.png';

const BearerTokenCopier = () => {
  const { bearerToken } = useUserContext();
  const { showToast } = useToast();

  const copyTokenToClipboard = () => {
    if (bearerToken) {
      navigator.clipboard
        .writeText(bearerToken)
        .then(() => {
          showToast('Bearer token copied to clipboard!', ToastType.SUCCESS);
        })
        .catch((err) => {
          showToast('Failed to copy bearer token', ToastType.DANGER);
          console.error('Failed to copy text: ', err);
        });
    } else {
      showToast('No bearer token available', ToastType.DANGER);
    }
  };

  return (
    <Tooltip title="Copy Bearer Token">
      <IconButton
        onClick={copyTokenToClipboard}
        size="small"
        sx={{
          width: 'fit-content',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
          padding: '4px',
        }}
      >
        <img
          src={BearerTokenIcon}
          alt="Bearer Token"
          style={{
            width: '18px',
            height: '18px',
            objectFit: 'contain',
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default BearerTokenCopier;
